import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { ArrowForwardRounded } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import * as S from 'console/shared/components/panels/heating-circuits/heating-circuit/styles';
import { formatTemp } from 'utils';
export const BoilerHeatingCircuitSetpointState = memo(function BoilerHeatingCircuitTargetState(props) {
    const { setpoint_temperature, ...rest } = props;
    return (_jsxs(S.TargetState, { ...rest, children: [_jsx(Typography, { fontSize: "0.6em", children: "\u0420\u0430\u0441\u0447\u0451\u0442\u043D\u0430\u044F" }), _jsxs(Box, { display: "flex", alignItems: "center", columnGap: "2px", children: [_jsx(ResponsiveIcon, { Icon: ArrowForwardRounded, color: "inherit", fontSize: "0.6em" }), _jsx(Typography, { component: "span", fontSize: "0.6em", children: setpoint_temperature != null
                            ? formatTemp(setpoint_temperature)
                            : '??' })] })] }));
});
